import {
  ActionIcon as MantineActionIcon,
  ActionIconProps as MantineActionIconProps,
} from '@mantine/core';

export type ActionIconProps = MantineActionIconProps;

export const ActionIcon = MantineActionIcon;

ActionIcon.displayName = 'ActionIcon';
